// extracted by mini-css-extract-plugin
export default {"invalidDataError":"addFaqProductStyle_invalidDataError__dqhQJ"};